





















































































































import Vue from "vue";

import { EventBus } from "@/eventbus";
import { ref } from "@vue/composition-api";
import { UsePopup } from "@/components/root/popup/popup.state";
import { remToPx } from "@/common/dom.functions";
import JustificationReasonPopupVue from "./JustificationReasonPopup.vue";
export default Vue.extend({
  props: ["source"],
  setup(props) {
    const tableRow = ref(null);

    const show_event_details = () => {
      EventBus.emit("details", props.source);
    };

    const showMenu = (event: MouseEvent) =>
      EventBus.emit("showMenu", { item: props.source, event });

    const show_statement = async (ev: MouseEvent, statement: string) => {
      await UsePopup.showDisplayPopup({
        type: "CustomDisplayPopup",
        items: [statement],
        cmp: JustificationReasonPopupVue,
        position: "left",
        width: remToPx(30),
        event: ev,
      });
    };

    return {
      show_event_details,
      showMenu,
      tableRow,
      show_statement,
    };
  },
});
